import createVueApp from '@/common/create_app'

Styxie.Initializers.Pricing = {
  show: async(props) => {
    const { default: Pricing } = await import('@/vue_widgets/pricing/index.vue')
    createVueApp(Pricing, { props })
  }
}
